import { Schema } from '@app/Modules/type';
import { Fragment } from 'react';
import { Button, Chip } from '@mui/joy';
import { Link } from 'react-router-dom';
import { AppIcon } from '@app/components/AppIcon';
import { StatusChip } from './StatusChip';
import ModificationBadge from '@app/Modules/collaborateur/PotentielsParrainages/components/ModificationBadge';

type props = {
    data: any;
    schema: Schema;
};
export default function RenderCustomValue({ data, schema }: props) {
    if (schema.ref === 'modificationStatus') {
        return <ModificationBadge potentielId={data.id} />;
    } else if (schema.ref === 'customFacturesPersonnePhysique') {
        data = data.parrainageAccordDe.concat(data.parrainagePersonnePhysique);
        return (
            <>
                {data.map((item: any, index: number) => (
                    <Fragment key={index}>
                        <div>{item.facture.numeroFacture}</div>
                    </Fragment>
                ))}
            </>
        );
    } else if (schema.ref === 'customFacturePersonneMoral') {
        return (
            <>
                {data.parrainagePersonneMorale.map(
                    (item: any, index: number) => (
                        <Fragment key={index}>
                            <div>{item.facture?.numeroFacture}</div>
                        </Fragment>
                    )
                )}
            </>
        );
    } else if (schema.ref === 'fournisseur/nom') {
        return (
            <>
                {data.fournisseur.map((item: any, index: number) => (
                    <Fragment key={index}>
                        <div>{item.nom}</div>
                    </Fragment>
                ))}
            </>
        );
    } else if (schema.newRedirect) {
        let to = '';
        if (typeof schema.newRedirect === 'function') {
            to = schema.newRedirect(data);
        } else if (typeof schema.newRedirect === 'string') {
            to = schema.newRedirect.replace(/\{(\w+)\}/g, (_, key) => data[key] ?? '');
        }
        return (
            <Link to={to} className="no-underline">
                <StatusChip
                    color="blue"
                    title="Détails"
                    icon="ChevronRightIcon"
                    iconEnd
                    handleClick={() => {}}
                    solid={false}
                />
            </Link>
        );
    }
}
